import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaptchaDto } from 'app/models/captcha/captcha.model';
import { Observable } from 'rxjs';
import { ConfigsLoaderService } from './config-loader.service';

@Injectable({providedIn: 'root'})
export class CaptchaService {

    private apiEndPoint: string;

    constructor(
        private http: HttpClient,
        private config: ConfigsLoaderService,
    ) {
        this.apiEndPoint = config.apiUrl;
    }


    getCaptcha(captchaGuid: string): Observable<CaptchaDto>{
        return this.http.get<CaptchaDto>(this.apiEndPoint + '/Captcha/GetCaptcha/' + captchaGuid);
    }

    validateCaptcha(captcha: string, captchaGuid: string){
        return this.http.get(this.apiEndPoint + '/Captcha/ValidateCaptcha/' + captcha + '/' + captchaGuid);
    }
}